import { render, staticRenderFns } from "./compositePanelHost.vue?vue&type=template&id=4ebee6be&scoped=true"
import script from "./compositePanelHost.vue?vue&type=script&lang=js"
export * from "./compositePanelHost.vue?vue&type=script&lang=js"
import style0 from "./compositePanelHost.vue?vue&type=style&index=0&id=4ebee6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebee6be",
  null
  
)

export default component.exports